import { render, staticRenderFns } from "./layout-divider.vue?vue&type=template&id=1b625c19&scoped=true"
import script from "./layout-divider.vue?vue&type=script&lang=js"
export * from "./layout-divider.vue?vue&type=script&lang=js"
import style0 from "./layout-divider.vue?vue&type=style&index=0&id=1b625c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b625c19",
  null
  
)

export default component.exports